module.exports = __webpack_public_path__ + "img/org-logo.5707a15d.svg";